import { Pipe, PipeTransform } from '@angular/core'
import { filesize, FilesizeOptions } from 'filesize'

@Pipe({
  name: 'filesize',
  standalone: true,
})
export class FilesizePipe implements PipeTransform {
  transform(value: number, options?: FilesizeOptions): string {
    return filesize(value, options) as string
  }
}
